import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
const useStyles = makeStyles(({
  palette,
  transitions
}) => ({
  container: {
    minWidth: 120
  },
  item: {
    borderRadius: 5,
    padding: "8px 16px"
  },
  yes: {
    color: palette.secondary.main
  },
  yesHover: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#C6E1E2"
    },
    transition: transitions.create(["background-color", "transform"], {
      duration: transitions.duration.complex
    })
  },
  yesActive: {
    backgroundColor: "#C6E1E2"
  },
  no: {
    color: palette.error.main
  },
  noHover: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#E8CAD8"
    },
    transition: transitions.create(["background-color", "transform"], {
      duration: transitions.duration.complex
    })
  },
  noActive: {
    backgroundColor: "#E8CAD8"
  }
}));
const BinaryRatingSystem = ({
  message,
  fontSize,
  fontWeight,
  onClick,
  disabled
}) => {
  const classes = useStyles();
  const rating = parseInt(message.customerScore);
  const isEventEnabled = typeof onClick === "function" && !disabled;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between",
    className: classes.container
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    onClick: isEventEnabled ? () => onClick(1) : null,
    className: `${classes.yes} ${classes.item} ${isEventEnabled ? classes.yesHover : ""} ${rating === 1 ? classes.yesActive : ""}`
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontSize,
      fontWeight
    }
  }, "YES")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    onClick: isEventEnabled ? () => onClick(0) : null,
    className: `${classes.no} ${classes.item} ${isEventEnabled ? classes.noHover : ""} ${rating === 0 ? classes.noActive : ""}`
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontSize,
      fontWeight
    }
  }, "NO")));
};
BinaryRatingSystem.propTypes = {
  onClick: PropTypes.func,
  message: PropTypes.object,
  fontSize: PropTypes.number,
  disabled: PropTypes.bool,
  fontWeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
BinaryRatingSystem.defaultProps = {
  message: {
    customerScore: -1
  },
  fontWeight: 600,
  disabled: false,
  fontSize: 14
};
export default BinaryRatingSystem;